import { render, staticRenderFns } from "./billOfLading.vue?vue&type=template&id=01b98da1&scoped=true&"
import script from "./billOfLading.vue?vue&type=script&lang=js&"
export * from "./billOfLading.vue?vue&type=script&lang=js&"
import style0 from "./billOfLading.vue?vue&type=style&index=0&id=01b98da1&lang=scss&scoped=true&"
import style1 from "./billOfLading.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b98da1",
  null
  
)

export default component.exports